export default "__VITE_ASSET__06e7029a__"